import type { ActivityDetailsResponse } from '../types/activity';
import type { ActivityDetailsData } from '../components/activity-details/types';

import activityImage from '../../assets/images/default-activity.jpeg';

/**
 * Transform backend activity details response to frontend component format
 */
export function transformActivityDetails(
  backendActivity: ActivityDetailsResponse
): ActivityDetailsData {
  return {
    id: backendActivity.id,
    title: backendActivity.title,
    description: backendActivity.description,
    imageUrl: backendActivity.imageUrl ?? activityImage,
    likesCount: backendActivity?.statistics?.thumbsUpCount ?? 0, // Use real thumbsUpCount from backend
    metadata: {
      duration: backendActivity.durationText,
      playType: backendActivity.playTypeText,
      prepNeeded: backendActivity.prepNeededText,
    },
    tags: backendActivity.tags.map((tag, index) => ({
      id: tag.id || `tag-${index}`,
      label: tag.label,
    })),
    recommendedFor: undefined, // Placeholder - recommendations not implemented yet
    steps: backendActivity.steps.map((step, index) => ({
      id: index + 1,
      text: step.text,
      emphasis: step.emphasis,
    })),
    tips: backendActivity.tips.map((tip, index) => ({
      id: index + 1,
      text: tip.text,
      boldText: tip.boldText,
    })),
    whyItWorks: {
      text: backendActivity.whyItWorks.text,
      boldKeywords: backendActivity.whyItWorks.boldKeywords,
    },
    recommendations: [], // Placeholder - recommendations not implemented yet
  };
}
